module.exports = __webpack_public_path__ + "img/odnoklassniki.730ee9c.svg";